import React from 'react';
import { Row, Col, Form, Card } from 'react-bootstrap';

/**
 * Araç formlarında kullanılan Teknik Özellikler formu
 * 
 * @param {Object} props.data - Form verisi (formData veya vehicle)
 * @param {Function} props.handleChange - Input değişikliklerini yakalayan fonksiyon
 */
const VehicleTechnicalForm = ({ data, handleChange }) => {
    return (
        <Card className="mb-4">
            <Card.Header>Teknik Özellikler</Card.Header>
            <Card.Body>
                <Row>
                    <Col md={4}>
                        <Form.Group className="mb-3" controlId="mileage">
                            <Form.Label>Kilometre</Form.Label>
                            <Form.Control
                                type="number"
                                name="mileage"
                                value={data.mileage || ''}
                                onChange={handleChange}
                                placeholder="Kilometre bilgisi"
                                required
                            />
                        </Form.Group>
                    </Col>

                    <Col md={4}>
                        <Form.Group className="mb-3" controlId="fuelType">
                            <Form.Label>Yakıt Tipi</Form.Label>
                            <Form.Select
                                name="fuelType"
                                value={data.fuelType || 'Benzin'}
                                onChange={handleChange}
                                required
                            >
                                <option value="Benzin">Benzin</option>
                                <option value="Dizel">Dizel</option>
                                <option value="LPG">LPG</option>
                                <option value="Elektrik">Elektrik</option>
                                <option value="Hibrit">Hibrit</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>

                    <Col md={4}>
                        <Form.Group className="mb-3" controlId="transmission">
                            <Form.Label>Vites Tipi</Form.Label>
                            <Form.Select
                                name="transmission"
                                value={data.transmission || 'Manuel'}
                                onChange={handleChange}
                                required
                            >
                                <option value="Manuel">Manuel</option>
                                <option value="Otomatik">Otomatik</option>
                                <option value="Yarı Otomatik">Yarı Otomatik</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>

                <Row>
                    <Col md={4}>
                        <Form.Group className="mb-3" controlId="color">
                            <Form.Label>Renk</Form.Label>
                            <Form.Control
                                type="text"
                                name="color"
                                value={data.color || ''}
                                onChange={handleChange}
                                placeholder="Örn: Beyaz, Siyah"
                                required
                            />
                        </Form.Group>
                    </Col>

                    <Col md={4}>
                        <Form.Group className="mb-3" controlId="city">
                            <Form.Label>Şehir</Form.Label>
                            <Form.Control
                                type="text"
                                name="location.city"
                                value={data.location?.city || ''}
                                onChange={handleChange}
                                placeholder="Şehir"
                                required
                            />
                        </Form.Group>
                    </Col>

                    <Col md={4}>
                        <Form.Group className="mb-3" controlId="district">
                            <Form.Label>İlçe</Form.Label>
                            <Form.Control
                                type="text"
                                name="location.district"
                                value={data.location?.district || ''}
                                onChange={handleChange}
                                placeholder="İlçe"
                                required
                            />
                        </Form.Group>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
};

export default VehicleTechnicalForm;